import { render } from "./PhonicsTask.vue?vue&type=template&id=62a8f13c"
import script from "./PhonicsTask.vue?vue&type=script&lang=js"
export * from "./PhonicsTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__